export const ActionType = {
    drawLine: 0,
    drawRect: 1,
    drawCircle: 2,
    drawText: 3
}